import { ETooltipIntents, ETypographyIntents } from '@src/typings';
import { TooltipVariants } from '@src/utilities/tooltipVariants';
import {
    HiOutlineExclamationCircle,
    HiOutlineQuestionMarkCircle,
} from 'react-icons/hi2';
import { twMerge } from 'tailwind-merge';
import { withTheme } from '../ThemeProvider';
import { Typography } from '../Typography';
import { StyledTooltip, StyledTooltipContainer } from './styles';
import { TooltipProps } from './types';

const TooltipComponent = ({
    title,
    className,
    intent = ETooltipIntents.Info,
    color = 'primary',
}: TooltipProps) => {
    return (
        <StyledTooltip
            trigger="click"
            title={
                <Typography intent={ETypographyIntents.Regular}>
                    {title}
                </Typography>
            }
            arrow={false}
        >
            <StyledTooltipContainer
                $color={color}
                className={twMerge(
                    TooltipVariants({
                        className,
                        intent,
                        color,
                    })
                )}
            >
                {intent === ETooltipIntents.Info ? (
                    <HiOutlineExclamationCircle className="min-w-4 min-h-4 text-base" />
                ) : (
                    <HiOutlineQuestionMarkCircle className="min-w-4 min-h-4 text-base" />
                )}
            </StyledTooltipContainer>
        </StyledTooltip>
    );
};

export const Tooltip = withTheme(TooltipComponent);
